import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './RelatedProductsList.module.scss';

const RelatedProductsList = ({ title, items }) => {

    const useColumns = items && items.length >= 6;

    return (
        <div className={styles['RelatedProductsList']}>
            <div className={styles['RelatedProductsList__Container']}>
                <h2 className={styles['RelatedProductsList__Title']}>{title}</h2>
                {items &&
                    <ul className={classNames(styles['RelatedProductsList__List'], {
                        [styles['RelatedProductsList__List--Columns']]: useColumns,
                    })}>
                        {items.map((item, index) => (
                            <li
                                key={index}
                                className={styles['RelatedProductsList__ListItem']}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    );
};

RelatedProductsList.propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string)
};

RelatedProductsList.defaultProps = {
    items: []
};

export default RelatedProductsList;
